const featureNames = {
  INSIGHTS: "INSIGHTS",
  PIP: "PIP",
};

module.exports = { featureNames };
